import { combineReducers } from '@reduxjs/toolkit';
import campaignsSlice from '../slices/campaignsSlice';

const rootReducer = combineReducers({
  campaigns: campaignsSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
